exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._11HDLALtvs00F0ctQteW11{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._11HDLALtvs00F0ctQteW11{padding-bottom:5px}html[dir=ltr] ._3e1mViraMdXPWxdjopO8St{float:right;padding-right:20px}html[dir=rtl] ._3e1mViraMdXPWxdjopO8St{float:left;padding-left:20px}._1fG_1WxUkKLEVrR7x1p5G4{width:200px}._1R7SHknrkMY2LnOCaCMw22{width:280px}", ""]);

// exports
exports.locals = {
	"details": "_11HDLALtvs00F0ctQteW11",
	"button": "_3e1mViraMdXPWxdjopO8St",
	"displayName": "_1fG_1WxUkKLEVrR7x1p5G4",
	"smtp": "_1R7SHknrkMY2LnOCaCMw22"
};